import React from 'react';
import { ReactComponent as Web } from '../images/development-icon.svg';
import { ReactComponent as Frontend } from '../images/frontend-icon.svg';
import { ReactComponent as Backend } from '../images/backend_icon.svg';


const Services = () => {
    return (
        <div id='services'>
            <h1 className='text-center my-10 text-4xl font-bold text-white'>My  <span className='text-neutral' >Services</span></h1>


            <div className='cards grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-5 '>

                <div data-aos="flip-left" className="card  bg-accent shadow-xl fancy-card">
                    <div className="card-body w-full text-white hover:text-black">
                        
                        {/* <img className='w-20' src={web} alt="" /> */}
                        <Web className='service-icon' />
                        <h2 className="card-title my-3">Web Development</h2>
                        <p>Fast load times and lag free interaction, my highest priority.Fast load times and lag free interaction, my highest priority.</p>

                    </div>
                </div>



                <div data-aos="flip-left" className="card  bg-accent shadow-xl fancy-card">
                    <div className="card-body w-full text-white hover:text-black">
                        {/* <img className='w-20' src={uiux} alt="" /> */}
                        <Frontend className='service-icon' />
                        <h2 className="card-title my-3">UI/UX Design</h2>
                        <p>Strong preference for easy to use, intuitive UX/UI.Strong preference for easy to use, intuitive UX/UI.</p>

                    </div>
                </div>



                <div data-aos="flip-left" className="card  bg-accent shadow-xl fancy-card">
                    <div className="card-body w-full text-white hover:text-black">
                        {/* <img className='w-20' src={server} alt="" /> */}
                        <Backend className='service-icon' />
                        <h2 className="card-title my-3">Database Management</h2>
                        <p>Websites don't have to be static, I love making pages come to life.Websites don't have to be static, I love making pages come to life.</p>

                    </div>
                </div>



            </div>
        </div>
    );
};

export default Services;